import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';


export const useDeepCompareMemo = <T>(value: T): T => {
    const ref = useRef<T>(value);

    useEffect(() => {
        if (!isEqual(value, ref.current)) {
            ref.current = value;
        }
    }, [value]);

    return ref.current;
};

